import { render, staticRenderFns } from "./index.vue?vue&type=template&id=726d5cea&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=726d5cea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726d5cea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('726d5cea')) {
      api.createRecord('726d5cea', component.options)
    } else {
      api.reload('726d5cea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=726d5cea&scoped=true", function () {
      api.rerender('726d5cea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/beta-groups/index.vue"
export default component.exports